import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404 catch-all page — keeps the user in the SPA
 * and provides a clear path back home.
 */
function NotFound() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '40px 20px',
      fontFamily: "'Segoe UI', sans-serif",
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
    }}>
      <div style={{ fontSize: '72px', marginBottom: '16px' }}>🎓</div>
      <h1 style={{ fontSize: '96px', fontWeight: 800, margin: 0, lineHeight: 1 }}>404</h1>
      <h2 style={{ fontSize: '1.8rem', marginTop: '16px', marginBottom: '8px' }}>
        Oops! Page Not Found
      </h2>
      <p style={{ fontSize: '1.1rem', opacity: 0.9, maxWidth: '480px', marginBottom: '32px' }}>
        The page you're looking for doesn't exist or has been moved.
        Let's get you back on track.
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          padding: '14px 32px',
          background: '#fff',
          color: '#667eea',
          borderRadius: '30px',
          textDecoration: 'none',
          fontWeight: 700,
          fontSize: '1rem',
          transition: '0.3s',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        }}
      >
        ← Back to Home
      </Link>
    </div>
  );
}

export default NotFound;
